import { render, staticRenderFns } from "./ChannelGroupCopyModal.vue?vue&type=template&id=70e44a65&"
import script from "./ChannelGroupCopyModal.vue?vue&type=script&lang=ts&"
export * from "./ChannelGroupCopyModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports